<template>
    <div class="py-1">
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <div v-on="tooltip ? on : null">
                    <stroke
                        :strike="(product?.archived || strike) && enableStrike"
                        class="mr-1 mb-1"
                    >
                        <span class="mr-1 mb-0 mt-sm-0">
                            <div class="align-center">
                                <div v-if="code && !inlineCode" class="mb-1 mr-2">
                                    <ScopedRouteLink
                                        v-if="type && product && canLinkToType"
                                        :to="{
                                            name: type,
                                            params: { product_id: product.id },
                                        }"
                                    >
                                        {{ codeValue }}
                                    </ScopedRouteLink>
                                    <template v-else>
                                        {{ codeValue }}
                                    </template>
                                </div>
                                <div class="product-name-title-row d-flex align-center flex-wrap">
                                    <span class="font-weight-bold product-name-title-text">
                                        <template
                                            v-if="displayCode && inlineCode && codeValue"
                                            >
                                            
                                            <ScopedRouteLink
                                                v-if="
                                                    code &&
                                                    inlineCode &&
                                                    product?.id != null &&
                                                    type &&
                                                    canLinkToType
                                                "
                                                :to="{
                                                    name: type,
                                                    params: { product_id: product.id },
                                                }"
                                            >
                                                {{ codeValue }}
                                            </ScopedRouteLink>
                                            <template v-else>
                                                {{ codeValue }}
                                            </template>
                                            -
                                        </template>

                                        <template v-if="label">{{ label }}</template>
                                        <template v-else-if="product">{{
                                            product.name
                                        }}</template>

                                        <i class="warning--text" v-else>{{ $translate('noName') }}</i>
                                        <template
                                            v-if="displayManufacturer && manufacturerValue"
                                        >
                                            <i class="grey--text text--darken-2 text-justify">
                                                {{ isMobile ? "" : "-" }}
                                                {{ manufacturerValue }}</i
                                            >
                                        </template>
                                    </span>
                                    <div
                                        v-if="chips && chips.length"
                                        class="product-name-chips-nowrap d-flex flex-nowrap align-center"
                                    >
                                        <v-chip
                                            v-for="(chip, idx) in chips"
                                            :key="idx"
                                            x-small
                                            class="product-name-chip"
                                            :color="chip.color || 'default'"
                                            :text-color="chip.textColor || 'white'"
                                            :outlined="!!chip.outlined"
                                        >
                                            <v-icon
                                                v-if="chip.icon"
                                                left
                                                x-small
                                            >
                                                {{ chip.icon }}
                                            </v-icon>
                                            {{ chip.label }}
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="
                                    (descriptionValue && displayDescription)
                                    || formatLabel
                                "
                                class="mt-0 wrap product-name-meta-row"
                            >
                                <template v-if="descriptionValue && displayDescription">
                                    {{ descriptionValue }}
                                </template>
                                <template
                                    v-if="
                                        formatLabel
                                        && descriptionValue
                                        && displayDescription
                                    "
                                >
                                    {{ " - " }}
                                </template>
                                <span
                                    v-if="formatLabel"
                                    class="text-caption grey--text text--darken-1 product-name-format-label"
                                >
                                    {{ formatLabel }}
                                </span>
                            </div>
                        </span>
                    </stroke>
                </div>
            </template>
            <span>{{ tooltip }}</span>
        </v-tooltip>
    </div>
</template>

<script>
import GlobalMixins from "@/mixins/global";
import { canAccessNavigationRoute } from "@/utils/navigationPermissions";

export default {
    mixins: [GlobalMixins],
    props: {
        product: {
            required: false,
            type: Object,
        },
        label: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        code: {
            type: String,
            default: null,
        },
        manufacturer: {
            type: String,
            default: null,
        },
        displayDescription: {
            type: Boolean,
            default: true,
        },
        displayManufacturer: {
            type: Boolean,
            default: true,
        },
        displayCode: {
            type: Boolean,
            default: false,
        },
        inlineCode: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "product",
        },
        strike: {
            type: Boolean,
            default: false,
        },
        enableStrike: {
            type: Boolean,
            default: true,
        },
        tooltip: {
            type: String,
            default: null,
        },
        chips: {
            type: Array,
            default: () => [],
        },
        formatLabel: {
            type: String,
            default: null,
        },
    },
    computed: {
        manufacturerValue() {
            if (this.manufacturer) {
                return this.manufacturer;
            }
            return this.product?.manufacturer;
        },
        descriptionValue() {
            if (
                this.description != null
                && String(this.description).trim()
            ) {
                return this.description;
            }
            return this.product?.description;
        },
        codeValue() {
            if (this.code !== null) {
                return this.code;
            }
            // Prefer UPC over code if available
            return this.product?.upc || this.product?.code;
        },
        canLinkToType() {
            return this.type && canAccessNavigationRoute(this.type);
        },
    },
    i18n: {
        messages: {
            en: {
                noName: "No name",
            },
            fr: {
                noName: "Pas de nom",
            },
        },
    },
};
</script>

<style scoped>
.product-name-title-row {
    column-gap: 4px;
    row-gap: 4px;
}
.product-name-chips-nowrap {
    flex-wrap: nowrap;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    column-gap: 4px;
}
.product-name-chip {
    flex-shrink: 0;
}
.product-name-format-label {
    white-space: nowrap;
}
</style>
